import React, { useState } from "react";
import logo from "../../assets/images/logo1.png";
import CustomSvg from "../svgs/CustomSvg";
import { useNavigate } from "react-router-dom";
import { forgotPassword } from "../apiRequests/requestApi";
import { useUser } from "../../utils/hooks";

export default function ForgotPassword({ accountType }) {
  const { setUserDetails, user } = useUser();
  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);

  const goToVerifyEmail = () => navigateTo("/forgot-password/verify-email");

  const [email, setEmail] = useState("");
  const [apiReqs, setApiReqs] = useState({ isLoading: false, errorMsg: null });

  const submit = async () => {
    try {
      setApiReqs({ ...apiReqs, isLoading: true, errorMsg: null });
      setUserDetails({ ...user, email });
      await forgotPassword({ email });
      goToVerifyEmail();
    } catch (error) {
      setApiReqs({ ...apiReqs, isLoading: false, errorMsg: "Something went wrong, try again" });
      // console.error(error);
    }
  };

  // Celebrity alternate design
  if (accountType === "celebrity") {
    return (
      <div className="login-bg-celebrity py-5 px-lg-5 px-md-5 px-3">
        
        <div className="d-flex align-items-center justify-content-center py-0">
          <div className="col-lg-5 p-4 align-items-center" style={{
            background: "rgba(34, 34, 51, 0.85)",
            borderRadius: "2rem",
            boxShadow: "0 8px 32px 0 rgba(31, 38, 135, 0.37)"
          }}>
            <h1 className="m-0 p-0 mb-4 font-weight-800 text-center font-family-quantico extra-large-txt"
              style={{
                background: "linear-gradient(94deg, #56920D 25.52%, #B7D080 84.53%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text"
              }}>
              Forgot <span style={{ color: "#B7D080" }}>Password?</span>
            </h1>
            <p className="m-0 p-0 mb-5 font-family-poppins text-center  txt-medium font-weight-400" style={{ color: "#fff", opacity: 0.85 }}>
             Enter an email address to get an OTP
code to reset your password.
            </p>
            <div className="mb-4 d-flex align-items-center justify-content-between p-3 rounded-pill shadow-sm"
              style={{
                background: "rgba(255,255,255,0.08)",
                border: "1px solid #B7D080"
              }}>
              <div style={{ width: "3%" }}>
                <CustomSvg name="mail" />
              </div>
              <input
                style={{
                  width: "94%",
                  background: "transparent",
                  border: "none",
                  color: "#fff"
                }}
                placeholder="Enter your email address"
                className="mx-lg-0 mx-md-0 mx-4 regular-txt font-family-quantico"
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <button
              onClick={submit}
              disabled={apiReqs.isLoading || !email}
              className="w-100 d-flex align-items-center justify-content-center p-3 mb-4 rounded-pill"
              style={{
                background: "linear-gradient(90deg, #56920D 0%, #B7D080 100%)",
                color: "#222233",
                fontWeight: "bold",
                border: "none",
                opacity: (!email || apiReqs.isLoading) ? 0.5 : 1,
                transition: "background 0.3s"
              }}
            >
              <p className="p-0 m-0 medium-txt font-weight-600 font-family-poppins mx-1">
                {apiReqs.isLoading ? "Please wait..." : "Continue"}
              </p>
              <div className="m-0 p-0 mx-2 d-flex align-items-center">
                <CustomSvg name={"arrow-right"} />
              </div>
            </button>
            {apiReqs.errorMsg && (
              <div className="mt-2" style={{ color: "#ff6a00", fontWeight: 500 }}>
                {apiReqs.errorMsg}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  // Default (non-celebrity) design
  return (
    <div className="email-verify-bg justify-center items-center py-4 px-lg-5 px-md-5 px-3">
      <div className="d-flex align-items-start flex-column mb-5">
        <div className="d-flex flex-column align-items-center justify-content-center">
          {/* <div className="mb-0 col-lg-8 d-flex align-items-center justify-content-center">
            <img src={logo} className="col-lg-12" alt="" />
          </div> */}
          {/* <h3 className="regular-txt text-white m-0 p-0 text-center font-family-quantico font-weight-500">
            SkyBoard
          </h3> */}
        </div>
      </div>
      <div className="d-flex text-white align-items-center justify-content-center py-0">
        <div
          className="col-lg-5 p-4 align-items-center mx-auto flex flex-col items-center"
        >
          <h1 className="m-0 p-0 mb-4 font-weight-800 md:text-3xl text-xl email-verify-email-txt font-family-quantico text-white extra-large-txt text-center">
            Forgot Password
          </h1>
          <p className="m-0 p-0 mb-5 opacity-_7 font-family-poppins text-sm font-weight-300 text-white text-center">
            Enter an email address to get an OTP code to reset your password
          </p>
          <div className="mb-4 flex items-center register-input-container justify-between p-2 w-full max-w-[400px] mx-auto">
            <div className="w-2">
              <CustomSvg name="mail" />
            </div>
            <input
              style={{ width: "94%" }}
              placeholder="Enter your email address"
              className="text-white mx-lg-0 mx-md-0 mx-4 text-sm font-family-quantico bg-transparent border-none outline-none"
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <button
            onClick={submit}
            className="w-full max-w-[400px] bg-pink-600 rounded-xl flex items-center justify-center p-2 mb-5"
            disabled={apiReqs.isLoading || !email}
            style={{ opacity: (!email || apiReqs.isLoading) ? 0.5 : 1 }}
          >
            <p className="p-0 m-0 text-white font-weight-500 font-family-poppins mx-1">
              {apiReqs.isLoading ? "Please wait..." : "Continue"}
            </p>
            <div className="m-0 p-0 mx-2 flex items-center">
              <CustomSvg name={"arrow-right"} />
            </div>
          </button>
          {apiReqs.errorMsg && (
            <div className="mt-2 text-center" style={{ color: "#ff6a00", fontWeight: 500 }}>
              {apiReqs.errorMsg}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}